import { put } from "redux-saga/effects";
import { GetUserMetadataResponse } from "redmond";
import fetchUserMetadata from "../../../api/v0/user/fetchUserMetadata";
import { actions } from "../actions";

export function* fetchHasSeenPackageSmokeTestSaga(
  _: actions.IFetchHasSeenPackageSmokeTest
) {
  try {
    const res: GetUserMetadataResponse = yield fetchUserMetadata({
      keys: ["hasSeenPackageSmokeTest"],
    });

    yield put(
      actions.setHasSeenPackageSmokeTest(
        res.userMetadata.hasSeenPackageSmokeTest
      )
    );
  } catch (e) {
    yield put(actions.setHasSeenPackageSmokeTest(false));
  }
}
